import React, { Fragment, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Button, Container, Row, Col, Form, Card } from 'react-bootstrap'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { enviarInformeAnalytic } from '../../api/api-descarga-analytic'
import {
  getInfoAnalyticPrevio,
  setLoadingTrue,
  setLoadingFalse
} from '../../store/actions/consultar-casos-analytic-action'

const calcularFechaDesde = (fechaHasta, diasAtras = 45) => {
  const fecha = new Date(fechaHasta)
  fecha.setDate(fecha.getDate() - diasAtras)
  return fecha.toISOString().split('T')[0] // Mantener formato yyyy-MM-dd
}

const obtenerRutUsuario = () => {
  const usuario = localStorage.getItem('user')
  if (usuario) {
    const usuarioObj = JSON.parse(usuario)
    return usuarioObj.rutUsuario
  }
  return null
}

const obtenerRutCompañia = () => {
  const usuario = localStorage.getItem('user')
  if (usuario) {
    const usuarioObj = JSON.parse(usuario)
    return usuarioObj.rutOrganizacion
  }
  return null
}

const BusquedaCasos = ({ onGenerarArchivo }) => {
  const [criterioFecha, setCriterioFecha] = useState('')
  const [fechaHasta, setFechaHasta] = useState(
    new Date().toISOString().split('T')[0]
  )
  const [fechaDesde, setFechaDesde] = useState(calcularFechaDesde(fechaHasta))
  const [situacionSiniestros, setSituacionSiniestros] = useState('')

  const data_analyticBuscar = useSelector(
    (state) => state.areaBusquedaCasosReducer
  )
  const { comboTipoFecha,comboSituacion } = data_analyticBuscar
  const dispatch = useDispatch()

  const formik = useFormik({
    initialValues: {
      fechaDesde,
      fechaHasta,
      estadoSiniestro: '',
      criterioFecha: ''
    },
    validationSchema: Yup.object({
      criterioFecha: Yup.string().required('Criterio por Fecha es obligatorio'),
      fechaDesde: Yup.date()
        .required('Fecha Desde es requerida')
        .test(
          'fecha-valida',
          'Fecha Desde no es válida',
          (value) => !isNaN(Date.parse(value))
        )
        .max(
          Yup.ref('fechaHasta'),
          'Fecha Desde debe ser menor o igual a Fecha Hasta'
        ),
      fechaHasta: Yup.date()
        .required('Fecha Hasta es requerida')
        .test(
          'fecha-valida',
          'Fecha Hasta no es válida',
          (value) => !isNaN(Date.parse(value))
        )
    }),
    onSubmit: async (formData) => {
      dispatch(setLoadingTrue())
      const nuevaFila = {
        estadoEmision: 'Emitido',
        rutUsr: obtenerRutUsuario(),
        criterio: criterioFecha,
        fechaDesde: criterioFecha==='0'?null:formData.fechaDesde,
        fechaHasta: criterioFecha==='0'?null:formData.fechaHasta,
        idCompania: obtenerRutCompañia()
      }

      try {
        await enviarInformeAnalytic(nuevaFila);        
        await dispatch(getInfoAnalyticPrevio()).finally(() => dispatch(setLoadingFalse()))
        setTimeout(async () => {dispatch(getInfoAnalyticPrevio());}, 4000);
      } catch (error) {
        console.error('Error al enviar al Lambda:', error)
        dispatch(setLoadingFalse())
      } finally {
        dispatch(setLoadingFalse()) 
      }
      handleLimpiar()
    }
  })

  const handleLimpiar = () => {
    setCriterioFecha('')
    const nuevaFechaHasta = new Date().toISOString().split('T')[0]
    setFechaHasta(nuevaFechaHasta)
    setFechaDesde(calcularFechaDesde(nuevaFechaHasta))
    setSituacionSiniestros('')
    formik.resetForm()
  }

  return (
    <Fragment>
      <Container className='mt-4'>
        <Card className='mt-2'>
          <Card.Header
            className='text-center'
            style={{ backgroundColor: '#4F517A', color: 'white' }}
          >
            Descarga de Siniestros Proceso Analytic
          </Card.Header>
          <Container style={{ padding: '20px 30px' }}>
            <Row>
              <Col md='3'>
                <Form.Label>Criterio por Fecha</Form.Label>
                <Form.Select
                  name='criterioFecha'
                  value={formik.values.criterioFecha}
                  onChange={(e) => {
                    formik.handleChange(e)
                    setCriterioFecha(e.target.value)
                  }}
                  isInvalid={!!formik.errors.criterioFecha}
                >
                  <option value=''>Seleccione...</option>
                  {comboTipoFecha?.comboTipoFecha?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre}
                    </option>
                  ))}
                  <option value='0'>No considera fecha</option>
                </Form.Select>
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.criterioFecha}
                </Form.Control.Feedback>
              </Col>
              <Col md='3'>
                <Form.Label>Fecha Desde</Form.Label>
                <Form.Control
                  type='date'
                  name='fechaDesde'
                  value={formik.values.fechaDesde} // Usar yyyy-MM-dd
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors.fechaDesde}
                  disabled={criterioFecha === '0' ? true : false}
                  lang='es-CL'
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.fechaDesde}
                </Form.Control.Feedback>
              </Col>
              <Col md='3'>
                <Form.Label>Fecha Hasta</Form.Label>
                <Form.Control
                  type='date'
                  name='fechaHasta'
                  value={formik.values.fechaHasta} // Usar yyyy-MM-dd
                  onChange={formik.handleChange}
                  isInvalid={!!formik.errors.fechaHasta}
                  disabled={criterioFecha === '0' ? true : false}
                  lang='es-CL'
                />
                <Form.Control.Feedback type='invalid'>
                  {formik.errors.fechaHasta}
                </Form.Control.Feedback>
              </Col>
              <Col md='3'>
                <Form.Label>Situación Siniestro CIA</Form.Label>
                <Form.Select
                  value={situacionSiniestros}
                  onChange={(e) => setSituacionSiniestros(e.target.value)}
                >
                  <option value=''>Seleccione...</option>
                  {comboSituacion?.comboSituacion?.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre}
                    </option>
                  ))}
                </Form.Select>
              </Col>
            </Row>
            <Row className='mt-3'>
              <Col className='d-flex justify-content-end align-items-end mt-4'>
                <Button
                  variant='warning'
                  className='me-2'
                  onClick={handleLimpiar}
                >
                  Limpiar
                </Button>
                <Button variant='danger' onClick={formik.handleSubmit}>
                  Generar archivo
                </Button>
              </Col>
            </Row>
          </Container>
        </Card>
      </Container>
    </Fragment>
  )
}

export default BusquedaCasos
